import { baseApi } from "../redux/baseAPI";

export const scheduleApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSchedule: builder.query({
      query: (params) => ({
        url: "/nursing_chats_notification_schedulers/index.json",
        method: "GET",
        params: params,
      }),
    }),
    addSchedule: builder.mutation({
      query: (body) => ({
        url: "/nursing_chats_notification_schedulers/add.json",
        method: "POST",
        data: body,
        body: body,
      }),
    }),
    deleteSchedule: builder.mutation({
      query: (body) => ({
        url: "/nursing_chats_notification_schedulers/delete.json",
        method: "POST",
        data: body,
        body: body,
      }),
    }),
    updateSchedule: builder.mutation({
      query: (body) => ({
        url: "/nursing_chats_notification_schedulers/update.json",
        method: "POST",
        data: body,
      }),
    }),
  }),
});

export const {
  useGetScheduleQuery,
  useAddScheduleMutation,
  useDeleteScheduleMutation,
  useUpdateScheduleMutation,
} = scheduleApi;
